import { Transactions } from "../../../shared/components/transactions/transactions";
import { UserTypes } from "../../../shared/constants";

export function FrontOfficeTransactions() {
  return <Transactions userType={UserTypes.Frontoffice} />;
}
